import React from 'react';
import { useSelector } from 'react-redux';
import {
  Table,
  TableBody,
  TableCell as MuiTableCell,
  TableHead,
  TableRow,
  withStyles,
} from '@material-ui/core';

import { PosPlugin } from 'plugins/plugin';
import { getCustomerRewardPointsSelector } from 'reducers/customerSearch';
import { getTotalVisitsToStore } from 'reducers/sales';

const UITableStats: PosPlugin['UITableStats'] = () => {
  const customerRewardPoints = useSelector(getCustomerRewardPointsSelector);
  const totalVisitsToStore = useSelector(getTotalVisitsToStore);

  const headers = ['', 'MyFit POINTS', 'VISIT'];
  const data = ['', customerRewardPoints, totalVisitsToStore];
  const TableCell = withStyles({
    root: {
      borderBottom: 'none',
    },
  })(MuiTableCell);

  const displayHeaders = headers.map((header, index) => (
    // eslint-disable-next-line prefer-template
    <TableCell
      key={`header${index + 1}`}
      style={{
        width: `${100 / headers.length}%`,
        color: '#ccc',
      }}
      padding="none"
    >
      {header}
    </TableCell>
  ));

  const displayTableStats = data.map((stat, index) => {
    let value = stat;
    let fullValue = stat;
    if (typeof stat === 'object') {
      ({ value, fullValue } = stat);
    }
    return (
      <TableCell
        data-testid="customer-stats"
        data-test-key={`customer-${fullValue}-${index}`}
        key={`stat${index + 1}`}
        title={`${fullValue}`}
        padding="none"
      >
        {value}
      </TableCell>
    );
  });

  return (
    <>
      <Table className="tableStats">
        <TableHead>
          <TableRow>{displayHeaders}</TableRow>
        </TableHead>
        <TableBody>
          <TableRow>{displayTableStats}</TableRow>
        </TableBody>
      </Table>
    </>
  );
};

export default UITableStats;
